import './ProjectCard.css';
import TagPills from '../TagPills/TagPills';
import { getImageSrc } from '../../utils/imageUtils';

export default function ProjectCard({
  tags = [],
  logo_url,
  logoUrl,
  title,
  challenge,
  solution,
  outcomes = [],
}) {
  const logoSrc = getImageSrc(logo_url || logoUrl);

  return (
    <article className="ProjectCard">
      <TagPills tags={tags} />

      {logoSrc ? (
        <span className="ProjectCard__logo">
          <img
            className="ProjectCard__logoImage"
            src={logoSrc}
            alt={title ? `${title} logo` : 'Project logo'}
            loading="lazy"
            decoding="async"
          />
        </span>
      ) : null}

      {title ? <h3 className="ProjectCard__title">{title}</h3> : null}

      {challenge ? (
        <div className="ProjectCard__section">
          <div className="ProjectCard__sectionTitle">Challenge</div>
          <p className="ProjectCard__sectionBody">{challenge}</p>
        </div>
      ) : null}

      {solution ? (
        <div className="ProjectCard__section">
          <div className="ProjectCard__sectionTitle">Solution</div>
          <p className="ProjectCard__sectionBody">{solution}</p>
        </div>
      ) : null}

      {outcomes.length ? (
        <div className="ProjectCard__section">
          <div className="ProjectCard__sectionTitle">Outcomes</div>
          <ul className="ProjectCard__list">
            {outcomes.map((outcome) => (
              <li key={outcome}>{outcome}</li>
            ))}
          </ul>
        </div>
      ) : null}
    </article>
  );
}
